
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { Plan, PlanRevisionRequest, PlanWithJobRequest } from "../../domain";
import { PlansRepository } from "../../repositories";
import { BaseResponse } from "planning-portal-library/src/lib/data/shared/base.response";

@Injectable({ providedIn: 'root' })
export class PlanRevisionUsecase implements UseCase<PlanRevisionRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: PlanRevisionRequest): Observable<boolean> {
    return this.planRepository.planRevision(params);
  }

}